import React, {useReducer} from 'react';
import StandingsHeader from 'app/components/standings/StandingsHeader';
import StandingsRow from 'app/components/standings/StandingsRow';
import {StandingInformation} from 'app/components/standings/StandingInformation';
import {fetchStandingByMatch} from 'app/routes/match/MatchPageActions';
import {LoadingIndicator, LOADING_MESSAGE, Placeholder} from '@fupa/fupa-uikit';
import {ContentWithStickyBanner} from 'app/styles/content';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';
import {MatchStandingPageReducer} from 'app/routes/match/MatchPageReducer';
import {useParams} from 'react-router';

const MatchStandingPage = ({matchInfo}) => {
  const {restoredData} = useRestoreData('MatchStandingPage');
  const {matchSlug} = useParams();
  const initialData = {
    isFetching: false,
    content: {},
    error: null,
  };
  const initialState = restoredData ?? initialData;

  const [state, dispatch] = useReducer(MatchStandingPageReducer, initialState);
  const loadData = () => {
    return fetchStandingByMatch(matchSlug)(dispatch, state);
  };

  const {content, isFetching, error} = state;
  const standings = content.standings || [];
  const helptext = content.text || null;
  useFetchData(state, loadData, 'MatchStandingPage');

  let standingsContent;
  if (isFetching) {
    standingsContent = <LoadingIndicator message={LOADING_MESSAGE.loadingStandings} bgColor />;
  } else if (!error && standings.length) {
    standingsContent = standings.map(row =>
      row.team ? (
        <StandingsRow
          key={row.team.id}
          team={row}
          homeTeamSlug={matchInfo?.homeTeam?.slug ?? ''}
          awayTeamSlug={matchInfo?.awayTeam?.slug ?? ''}
          gameType={matchInfo?.round ? matchInfo.round.type : null}
        />
      ) : null
    );
  } else if (!standings.length) {
    standingsContent = <Placeholder>Für dieses Spiel ist keine Tabelle verfügbar.</Placeholder>;
  } else if (error) {
    standingsContent = <Placeholder>Beim Laden der Tabelle ist ein Fehler aufgetreten.</Placeholder>;
  }

  const defaultContent = isFetching ? null : <StandingInformation helptext={helptext} standings={standings} />;

  return (
    <ContentWithStickyBanner>
      <StandingsHeader />
      {standingsContent}
      {defaultContent}
    </ContentWithStickyBanner>
  );
};

export default MatchStandingPage;
